import React, { useRef } from 'react'
import styled, { css } from 'styled-components'
import { Subject } from 'interfaces/Subject'
import { Know } from 'interfaces/Know'
import { Headline3 } from 'stories/elements/Typography/Text'
import theme from 'stories/utils/theme'
import { deviceSize } from 'lib/constants/GridBreakpoints'
import useMedia from 'lib/hooks/useMedia'
import {
    AnalyticsEventSimilarKnowsSectionImpression,
    AnalyticsEventSimilarKnowsButtonClick,
} from 'lib/constants/AnalyticsEventType'
import { trackEvent } from 'lib/tracking/analytics-service'
import { useRouter } from 'next/dist/client/router'
import { getReferrerScreen } from 'lib/formatting/url'
import WebappKnowCard from 'components/feature/Know/view/webapp/WebappKnowCard'
import useImpressionTracking from 'lib/hooks/useImpressionTracking'
import KnowDisplayCard from './KnowDisplayCard'

const Container = styled.div`
    display: grid;
    grid-gap: 20px;
    place-content: center;
    @media (max-width: 1050px) {
        h4 {
            text-align: center;
        }
    }
    @media (max-width: 750px) {
        padding: 15px 10px 25px 10px;
        background-color: ${theme.colors.violetBackground};
    }
`

const Section = styled.div<{ fullWidth?: boolean }>`
    width: ${({ fullWidth }) => (fullWidth ? '100%' : '425px')};
    height: auto;
    display: grid;
    place-items: center;

    @media (max-width: 1250px) {
        width: 100%;
    }
    .spacer {
        height: 25px;
    }
`

const ContentGrid = styled.div<{ centerContent?: boolean }>`
    display: flex;
    flex-wrap: wrap;
    row-gap: 0px;
    grid-gap: 25px;
    padding-bottom: 25px;

    ${({ centerContent }) =>
        centerContent
            ? css`
                  justify-content: center;
              `
            : ''}
    @media (max-width: 1050px) {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 20px;
    }
`

interface Props {
    knows: Know[]
    heading: string
    subject: Subject | null
    fullWidth?: boolean
    parentKnow: Know
}

const SidebarKnows = (props: Props) => {
    const md = useMedia(deviceSize.md)
    const tb = useMedia(deviceSize.tablet)
    const lg = useMedia(deviceSize.lg)
    const similarKnowsReferrerScreen = 'similar-knows'
    const router = useRouter()
    const referrerScreen = getReferrerScreen(router)
    const similarKnowsRef = useRef<HTMLDivElement>(null)

    useImpressionTracking(similarKnowsRef, AnalyticsEventSimilarKnowsSectionImpression, { referrerScreen })

    const filterKnows = () => {
        if (tb && !md) {
            return props.knows.slice(0, 3)
        }

        return props.knows
    }

    const onSimilarKnowsClicked = (know: Know) => {
        trackEvent(AnalyticsEventSimilarKnowsButtonClick, { know, referrerScreen })
    }

    const Card = lg ? WebappKnowCard : KnowDisplayCard

    return (
        <Container>
            <Headline3
                fontSize={lg ? 24 : 20}
                color={theme.colors.subtitleBlack}
                textAlign={'center'}
                fontFamily="var(--font-inter)"
            >
                {props.heading}
            </Headline3>

            <Section fullWidth={props.fullWidth} ref={similarKnowsRef}>
                <>
                    <ContentGrid centerContent>
                        {filterKnows()?.map((know) => (
                            <span key={know.uuid} onClick={() => onSimilarKnowsClicked(know)}>
                                <Card
                                    key={know.uuid}
                                    know={know}
                                    referrerScreen={similarKnowsReferrerScreen}
                                    knowUuid={know.uuid}
                                    showTitleAsSubHeadline
                                />
                            </span>
                        ))}
                    </ContentGrid>

                    <span className="spacer" />
                </>
            </Section>
        </Container>
    )
}

export default SidebarKnows
